import i18n from '../configs/i18n';
import { DATE, MONTH, QUARTER, TIME, WEEK, YEAR } from '../configs/dateFieldSubTypes';
import * as AXIS_SUB_TYPES from '../configs/grid/axisSubTypes';

export const getDateItems = (type = DATE) => {
  const types = [];
  switch (type) {
    case TIME:
      types.push(AXIS_SUB_TYPES.HOUR, AXIS_SUB_TYPES.HOUR_OF_DAY);
    case DATE:
      types.push(AXIS_SUB_TYPES.DAY, AXIS_SUB_TYPES.DAY_OF_WEEK);
    case WEEK:
      types.push(AXIS_SUB_TYPES.WEEK, AXIS_SUB_TYPES.WEEK_OF_YEAR);
    case MONTH:
      types.push(AXIS_SUB_TYPES.MONTH, AXIS_SUB_TYPES.MONTH_OF_YEAR);
    case QUARTER:
      types.push(AXIS_SUB_TYPES.QUARTER, AXIS_SUB_TYPES.QUARTER_OF_YEAR);
    case YEAR:
      types.push(AXIS_SUB_TYPES.YEAR);
  }

  return types.map((subType) => ({
    subType,
    title: `(${i18n.t(`reports.widget.modals.common.tabs.data.axis.types.${subType}`)})`,
  }));
};
